import { BasicUser } from "types/topicflow";

import Button from "@components/button/button";
import { buttonTheme } from "@components/button/button-constants";
import { TopicflowIconMap } from "@components/topicflow-icon/topicflow-icon-helpers";
import { classNames } from "@helpers/css";

const ImpersonateUser = ({
  user,
  isFavorited,
  onClickFavorite,
}: {
  user: BasicUser;
  isFavorited?: boolean;
  onClickFavorite: () => void;
}) => {
  return (
    <form action="/hijack/acquire/" method="POST">
      <input type="hidden" name="csrfmiddlewaretoken" value={window.TF.csrf} />
      <input type="hidden" name="user_pk" value={user.id} />

      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Button
            theme={buttonTheme.iconGray}
            icon={TopicflowIconMap.star}
            className={classNames(
              isFavorited ? "text-yellow-500" : "text-gray-400",
            )}
            onClick={onClickFavorite}
          />
          <div>
            <div className="text-gray-800 font-medium">{user.name}</div>
            <div className="text-gray-500 text-xs">
              {user.email} ({user.id})
            </div>
          </div>
        </div>

        <Button theme={buttonTheme.primary} text="Impersonate" type="submit" />
      </div>
    </form>
  );
};

export default ImpersonateUser;
